<template>
  <v-container fluid pa-0 ma-0>
    <v-card flat>
      <v-card-text>
        <v-window v-model="step">

          <v-window-item :value="1">
            <div v-if="passwordError">Incorrect password.</div>
            <div>Please enter the password to refund this transaction:</div>
            <v-text-field
              label="Password"
              v-model="password"
              append-icon="lock"
              box
              hide-details
              @keyup.native.enter="checkPassword"
              type="password"
            />
          </v-window-item>

          <v-window-item :value="2">
            <template>
              <div v-if="achWait">
                <span class="body-2 primary--text">WARNING</span> this ACH has not yet cleared the {{ achWaitDays }} business day wait period for refunds.
              </div>
              <v-form>
                <v-container fluid fill-height grid-list-xl pa-0 ma-0>
                  <v-radio-group v-model="refundType">
                    <v-layout row wrap align-center>
                      <v-flex xs6>
                        <v-radio
                          :label="credited ? 'Remaining Amount' : 'Full Amount'"
                          value="full"
                          color="primary"
                          class="mb-4"
                          hide-details
                        />
                      </v-flex>

                      <v-flex xs6 mb-3>
                        <span class="title">
                        ${{ ((transaction.total_amount - credited) / 100).toFixed(2) }}
                        </span>
                      </v-flex>

                      <template v-if="transaction.fee_amount && (transaction.total_amount - credited) > transaction.fee_amount">
                        <v-flex xs6>
                          <v-radio
                            label="Price Adj Fee"
                            value="fee"
                            v-if="transaction.fee_amount"
                            color="primary"
                            hide-details
                          />
                        </v-flex>

                        <v-flex xs6>
                          <span class="title">
                          ${{ (transaction.fee_amount / 100).toFixed(2) }}
                          </span>
                        </v-flex>
                      </template>

                      <v-flex xs6>
                        <v-radio
                          label="Partial Amount"
                          value="partial"
                          color="primary"
                          hide-details
                        />
                      </v-flex>
                      <v-flex xs6>
                        <v-text-field
                          v-model="refundAmount"
                          :disabled="refundType!='partial'"
                          append-icon="fa-dollar"
                          box
                          class="title"
                          hide-details
                        />
                      </v-flex>
                    </v-layout>
                  </v-radio-group>
                </v-container>
              </v-form>
            </template>
          </v-window-item>

          <v-window-item :value="3">
            <div class="mt-4">
              <span class="body-2 primary--text">WARNING</span> this ACH has not yet cleared at the bank. Although you have received the next day funding, you must wait {{ achWaitDays }} business days before issuing the refund.
            </div>

            <div class="mt-4">Please contact Customer Service for further assistance.</div>
          </v-window-item>

          <v-window-item :value="4">
            There was an error refunding the transaction: {{ error }}
          </v-window-item>
        </v-window>

      </v-card-text>

      <v-divider class="primary" v-if="step === 1 || step === 2"></v-divider>

      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn color="primary" @click="checkPassword" v-if="step === 1">Confirm</v-btn>
        <v-btn color="primary" @click="refund" v-if="step === 2">Refund</v-btn>
      </v-card-actions>

    </v-card>

  </v-container>
</template>

<script>
import Moment from 'moment'

import Bus from '@/bus'

import ApiMixin from '@/mixins/api'
import AuthMixin from '@/mixins/auth'
import DisplayMixin from '@/mixins/display'
import StoreMixin from '@/store/mixin'

export default {
  mixins: [ApiMixin, AuthMixin, DisplayMixin, StoreMixin],

  data: function () {
    return {
      refundType: 'full',
      refundAmount: null,
      step: 1,
      error: '',
      password: '',
      passwordError: false,
      achWaitDays: 7
    }
  },

  props: {
    transaction: Object
  },

  created () {
    if (this.achWait && !this.hasPermission('superuser') && !this.hasPermission('can_refund_ach_without_wait')) {
      this.step = 3
    } else if (!this.transaction.account_manager_password || this.hasPermission('can_refund_without_password')) {
      this.step = 2
    }
  },

  mounted () {
    if (this.appReady) {
      this.init()
    } else {
      Bus.$on('appReady', this.init)
    }
  },

  computed: {
    credited: function () {
      if (!this.transaction.hasOwnProperty('associatedTransactions') || this.transaction.associatedTransactions.length < 1) {
        return 0
      }

      let totalCredited = this.transaction.associatedTransactions.reduce((runningTotal, transaction) => {
        if ((transaction.request_type === 'credit' || transaction.request_type === 'achcredit') && transaction.response_code === '000' && transaction.parent_transaction_id === this.transaction.id && !transaction.voided) {
          return runningTotal + transaction.total_amount
        }
        return runningTotal
      }, 0)

      return totalCredited
    },

    achWait: function () {
      if (!(this.transaction.request_type === 'ach' || this.transaction.request_type === 'achcredit') || !this.transaction.settled) {
        return false
      }

      let count = 0
      let timeout = Moment(this.transaction.settled)

      while (count < this.achWaitDays) {
        timeout = timeout.add(1, 'days')

        // skip weekend days
        if (timeout.day() !== 0 && timeout.day() !== 6) {
          count++
        }
      }

      if (Moment().isBefore(timeout)) {
        return true
      }

      return false
    }
  },

  methods: {
    async init () {},

    closeOptionsModal (id = '') {
      this.refundType = 'full'
      this.refundAmount = null
      this.step = 1
      this.error = ''
      this.password = ''
      this.passwordError = false

      Bus.$emit('closeOptionsModal')

      if (id) {
        Bus.$emit('openTransaction', id)
      }
    },

    // @TODO exports.validateManagerPassword = async (user_id, account_id, token_id, password) => {
    checkPassword () {
      try {
        if (this.transaction.account_manager_password && !this.hasPermission('can_refund_without_password') && this.transaction.account_manager_password !== this.password) {
          this.passwordError = true
        } else {
          this.step = 2
        }
      } catch (err) {
        this.error = err
        this.step = 1
      }
    },

    async refund () {
      try {
        if (!this.transaction) {
          throw new Error('Unable to identify transaction')
        }

        if (this.transaction.voided) {
          throw new Error('Transaction has already been voided')
        }

        // let message = 'Refunding is not reversable, are you absolutely sure you would like to refund this transaction?'

        let options = {
          terminal_id: this.transaction.terminal_id,
          token_id: this.transaction.token_id,
          // transaction_id: this.transaction.custom_tracking_id,
          unique_id: this.transaction.tracking_id,
          type: this.$data.refundType
        }

        if (this.$data.refundType === 'partial') {
          if (!this.$data.refundAmount) {
            throw new Error('Unable to identify refund amount')
          }
          options.amount = this.$data.refundAmount
        }

        Bus.$emit('openWaitModal')
        let result = await this.api({
          method: 'post',
          url: `/terminal/refund`,
          data: options
        })
        Bus.$emit('closeWaitModal')

        if (result.data.response.ResponseText === 'RETURN ACCEPTED' || result.data.response.ResponseText === 'CHECK ACCEPTED') {
          // Bus.$emit('alertMessage', {status: 'success', message: 'Refunded successfully'})
          Bus.$emit('openModal', {
            status: 'success',
            message: 'Refunded successfully'
          })
          this.closeOptionsModal(result.data.response.UniqueID)
          // this.resultModalMessage = 'Refund successful'
          // this.resultModal = true
        } else {
          let error = result.data.response.ResponseText
          if (result.data.response.ErrMsg) {
            error += ': ' + result.data.response.ErrMsg
          }
          // Bus.$emit('alertMessage', {status: 'error', message: error})
          Bus.$emit('openModal', {
            status: 'error',
            message: error
          })
          // this.resultModalMessage = error
          // this.resultModalError = true
          // this.resultModal = true
        }
      } catch (err) {
        // this.$store.commit('error', err)
        // Bus.$emit('alertMessage', {status: 'error', message: err})
        Bus.$emit('openModal', {
          status: 'error',
          message: err
        })
        // this.resultModalMessage = err
        // this.resultModalError = true
        // this.resultModal = true
      }
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/transactions/Refund.vue